import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Home' })((theme) => ({
    search: {
        marginTop: 40,
        marginBottom: 120,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 16,
            marginBottom: 40
        }
    },
    section: {
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginBottom: 96
        }
    },
    title: {
        marginTop: 120,
        marginBottom: 200,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 40,
            marginBottom: 120
        }
    }
}));
